import React from "react";
import { SimpleLoading, HeaderHLPure, PromotionalFooterPure, DialogSystemGLPure } from "../../pures";
import { Container, Grid } from "@material-ui/core";
import "./digital-contract.css";
import QuestionnairesAdministrationAction from "../../actions/questionnaires-administration/questionnaires-administration.action";

const DigitalContractView = (props) => {
    let {
        isLoadingView,
        t,
        showLoadingRequesting,
        toggleErrorRequesting,
        showCompletedRequesting,
        toggleLoadingRequesting,
        showErrorRequesting,
        toggleCompletedRequesting,
        messageError,
        tabs,
        currentPage,
        changeRoute
    } = props

    let Tab = (tabs && tabs.length > 0) ? tabs[currentPage].component : null;
    let headerTitle = (tabs && tabs.length > 0) ? tabs[currentPage].header : t("digitalContractAction.routes.start.header")

    if (isLoadingView) return <SimpleLoading />

    const handleChangePage = (route) => {
        let includeState = (route === 'standar-contracts') ? true : false
        let state
        if (includeState) {
            state = {
                standardContract: true
            }
        }
        changeRoute(route, includeState, state)
    }

    return (
        <div className="standard-wrapper">
                <div className="digitalContractView-header">
                    <HeaderHLPure title={headerTitle} />
                </div>
                <div className="digitalContractView-body">
                    <div className="digitalLibraryView-menu-container">
                        <div className='digitalContractView-menu' role="tablist">
                                {
                                    tabs.map((tab, i) => {
                                        if (tab.hidden) return <></>
                                        return (
                                            <button
                                                key={tab.route}
                                                className='digitalContractView-menuItem'
                                                role='tab'
                                                aria-selected={i === currentPage}
                                                onClick={() => handleChangePage(tab.route)}
                                            >
                                                {tab.title}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        <div className='digitalContractView-menu-buttons'>
                        </div>
                    </div>
                    {
                        Tab ?
                            tabs[currentPage].route === 'questionnaires' ? (
                                <QuestionnairesAdministrationAction {...props} />
                            ) : (

                                <Grid item xs={12} role="tabpanel" aria-expanded={true}>
                                    <Tab {...props} />
                                </Grid>
                            )
                            : null
                    }
                </div>
                <Grid item xs={12}>
                    <PromotionalFooterPure />
                </Grid>
            <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}

                showCompletedRequesting={showCompletedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}

                showErrorRequesting={showErrorRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                messageError={messageError}
            />
        </div>
    )
}

export { DigitalContractView as default }